// Bands card game data - ranked by album sales + cultural impact
export const BANDS_CARDS = [
  { id: 1, name: "The Beatles", rank: 1, image: "/images/bands/bands_1.jpg" },
  { id: 2, name: "Led Zeppelin", rank: 2, image: "/images/bands/bands_2.jpg" },
  { id: 3, name: "Pink Floyd", rank: 3, image: "/images/bands/bands_3.jpg" },
  { id: 4, name: "Queen", rank: 4, image: "/images/bands/bands_4.jpg" },
  { id: 5, name: "The Rolling Stones", rank: 5, image: "/images/bands/bands_5.jpg" },
  { id: 6, name: "AC/DC", rank: 6, image: "/images/bands/bands_6.jpg" },
  { id: 7, name: "U2", rank: 7, image: "/images/bands/bands_7.jpg" },
  { id: 8, name: "Fleetwood Mac", rank: 8, image: "/images/bands/bands_8.jpg" },
  { id: 9, name: "Eagles", rank: 9, image: "/images/bands/bands_9.jpg" },
  { id: 10, name: "Aerosmith", rank: 10, image: "/images/bands/bands_10.jpg" },
  { id: 11, name: "The Beach Boys", rank: 11, image: "/images/bands/bands_11.jpg" },
  { id: 12, name: "Nirvana", rank: 12, image: "/images/bands/bands_12.jpg" },
  { id: 13, name: "Guns N' Roses", rank: 13, image: "/images/bands/bands_13.jpg" },
  { id: 14, name: "Coldplay", rank: 14, image: "/images/bands/bands_14.jpg" },
  { id: 15, name: "Bon Jovi", rank: 15, image: "/images/bands/bands_15.jpg" },
  { id: 16, name: "Metallica", rank: 16, image: "/images/bands/bands_16.jpg" },
  { id: 17, name: "Red Hot Chili Peppers", rank: 17, image: "/images/bands/bands_17.jpg" },
  { id: 18, name: "Oasis", rank: 18, image: "/images/bands/bands_18.jpg" },
  { id: 19, name: "R.E.M.", rank: 19, image: "/images/bands/bands_19.jpg" },
  { id: 20, name: "The Who", rank: 20, image: "/images/bands/bands_20.jpg" },
  { id: 21, name: "Def Leppard", rank: 21, image: "/images/bands/bands_21.jpg" },
  { id: 22, name: "Green Day", rank: 22, image: "/images/bands/bands_22.jpg" },
  { id: 23, name: "Imagine Dragons", rank: 23, image: "/images/bands/bands_23.jpg" },
  { id: 24, name: "Pearl Jam", rank: 24, image: "/images/bands/bands_24.jpg" },
  { id: 25, name: "The Police", rank: 25, image: "/images/bands/bands_25.jpg" },
  { id: 26, name: "Counting Crows", rank: 26, image: "/images/bands/bands_26.jpg" },
  { id: 27, name: "The Killers", rank: 27, image: "/images/bands/bands_27.jpg" },
  { id: 28, name: "Radiohead", rank: 28, image: "/images/bands/bands_28.jpg" },
  { id: 29, name: "The Doors", rank: 29, image: "/images/bands/bands_29.jpg" },
  { id: 30, name: "Foo Fighters", rank: 30, image: "/images/bands/bands_30.jpg" },
];
